import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

import ConsultationCTA from 'Containers/ConsultationCTA';

const FixedButton = styled.div<{ shouldShow: boolean }>`
  z-index: 100;
  display: flex;
  justify-content: center;
  left: 0;
  width: 100%;
  position: fixed;
  padding: ${theme.spacing['8x']};
  transition: bottom 500ms;
  bottom: ${({ shouldShow }) => (shouldShow ? 0 : -85)}px;

  ${mediaMinWidth('sm')} {
    justify-content: flex-end;
    padding: 0 ${theme.spacing['12x']} ${theme.spacing['8x']} 0;
  }
`;

const StyledButton = styled(ConsultationCTA)`
  width: 274px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
  border-radius: 2rem;
`;

type StickyConsultationCTAProps = {
  shouldShow: boolean;
  dataFrom?: string;
};

export const StickyConsultationCTA = ({ shouldShow, dataFrom }: StickyConsultationCTAProps) => (
  <FixedButton shouldShow={shouldShow}>
    <StyledButton dataFrom={dataFrom} noMargin variant="sorbetGreenOnHover" />
  </FixedButton>
);
